import { mdiFileDocumentOutline, mdiOpenInNew, mdiStarOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { useMatchRoute } from '@tanstack/react-router'

import { appInsights } from '@/analytics'
import { Box } from '@/components/ui/box'
import { Link } from '@/components/ui/link'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { ICitation } from '@/types/gigiChat/Citation'

const Citation = ({ icon = mdiOpenInNew, link, iconSize = '14px', text, isHighlighted = false, isOpen }: ICitation) => {
    const matchRoute = useMatchRoute()
    const defaultColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')
    const highlightColor = useColorModeValue('var(--chakra-colors-status-highlight)', 'var(--chakra-colors-status-highlight_dark)')
    const color = isHighlighted ? highlightColor : defaultColor
    const trackHighlightedCitations = () => {
        appInsights.trackEvent({ name: 'chat-citation-link-usedInCompletion' })
    }

    if (matchRoute({ to: '/documents' })) {
        const _icon = isHighlighted ? mdiStarOutline : mdiFileDocumentOutline
        return (
            <Box display="inline-flex" alignItems="center" mr="8px">
                <Icon path={_icon} size={iconSize} style={{ display: 'inline', verticalAlign: 'middle' }} color={color} />
                <Text as="span" fontSize="14px" letterSpacing="0.25px" color={color} ml="4px">
                    {text}
                </Text>
            </Box>
        )
    } else {
        const _icon = isHighlighted ? mdiStarOutline : icon
        return (
            <Box data-testid="chat-citation" display="inline-flex" alignItems="center" mr="8px" hidden={isHighlighted ? false : !isOpen}>
                <Icon path={_icon} size={iconSize} style={{ display: 'inline', verticalAlign: 'middle' }} color={color} />
                <Link
                    data-testid="chat-citation-link"
                    data-id="chat-citation-link"
                    href={link}
                    isExternal
                    textDecor="underline"
                    textDecorationColor={color}
                    textAlign="left"
                    ml="4px"
                    _hover={{
                        textDecorationColor: color,
                    }}
                    onClick={(e) => {
                        e.stopPropagation()
                        isHighlighted && trackHighlightedCitations()
                    }}
                >
                    <Text as="span" fontSize="14px" letterSpacing="0.25px" color={color}>
                        {text}
                    </Text>
                </Link>
            </Box>
        )
    }
}

export default Citation
